export default __webpack_public_path__ + "static/media/image4.9bdd2efc.svg";